import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFilterHistory } from "../../reduxStore/entities/historylogs.js";

import Table from "../../components/Table/Table.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";

import resources from "../../core/Localization/Localization.js";
import { defaultTableSize } from "../../common/OfferDetailsLayout";
import moment from "moment";
import { historyColumns } from "../../common/HistoryTabs.js";

const OfferHistory = ({ filter }) => {
    const navigate = useNavigate();

    const filterHistory = useSelector((state) => state.historyLogs.offerHistory);
    const dispatch = useDispatch();

    const [tableData, setTableData] = React.useState([]);

    const columns = React.useMemo(historyColumns, [resources]);

    React.useEffect(() => {
        window?.scrollTo(0, 0);
        dispatch(getFilterHistory(filter.part_offer_id));
    }, [filter]);

    React.useEffect(() => {
        const uh = [...filterHistory];
        if (uh && uh.length > 1) {
            uh.sort((x, y) => {
                if (x.createdAt > y.createdAt) {
                    return -1;
                }
                if (x.createdAt < y.createdAt) {
                    return 1;
                }
                return 0;
            });
        }
        setTableData(
            uh.map((x) => {
                return [
                    x.history_log_id,
                    `${x.model} ${x.action}`,
                    resources.historyLogs[x.type.toLowerCase()],
                    moment(x.createdAt).format("DD/MM/YYYY hh:mm:ss"),
                ];
            })
        );
    }, [filterHistory]);

    const onRowClick = (params) => {
        if (params.length) {
            navigate("/admin/history-logs/" + params[0]);
        }
    };

    return (
        <Card className={"user-profile-card"}>
            <CardHeader color="primary">
                <h4>{resources.historyLogs.header}</h4>
            </CardHeader>
            <CardBody>
                <Table
                    tableHeaderColor="primary"
                    tableHead={columns}
                    tableData={tableData}
                    //handleClick={onRowClick}
                    paginationInfo={{
                        pageSize: defaultTableSize,
                        pageSizeOptions: [defaultTableSize],
                    }}
                />
            </CardBody>
        </Card>
    );
};

export default OfferHistory;
